module.exports = __webpack_public_path__ + "static/media/meeting-room-icon--hover.6410b8bd.svg";